import { Action, createReducer, on } from '@ngrx/store';
import { JobActions } from './job.actions';

export const STORE_FEATURE_KEY_JOB = 'job';

export interface JobState {
    sendingMessageLoading: boolean;
    messageSendSuccessful: boolean;
}

export const initializeJobState: JobState = {
    sendingMessageLoading: false,
    messageSendSuccessful: false
};

const reducer = createReducer(
    initializeJobState,
    on(JobActions.sendTestMessage, (state, payload) =>
        ({ ...state,
           sendingMessageLoading: true,
           messageSendSuccessful: false
        })),
    on(JobActions.sendTestMessageSuccess, (state, payload) =>
        ({ ...state,
           sendingMessageLoading: false,
           messageSendSuccessful: true
        })),
    on(JobActions.sendTestMessageFailed, (state, payload) =>
        ({ ...state,
           sendingMessageLoading: false,
           messageSendSuccessful: false
        }))
);

export function JobReducers(state: JobState | undefined, action: Action): JobState {
    return reducer(state, action);
}
